<template>
  <div style="height: 100%;background-color: #fbfbfb;padding: 20px;box-sizing: border-box;">
    <div style="height: 50px">
      <el-button type="warning" plain @click="addDevice()">录入设备</el-button>
      &nbsp;&nbsp;
      <el-input placeholder="输入设备编号" v-model="deviceid" style="width: 250px"></el-input>&nbsp;&nbsp;
      <el-button type="success" @click="queryDataTable">查询</el-button>
    </div>
    <div class="content-bottom">
      <el-table v-loading="loading" element-loading-text="加载中，请耐心等待。" :data="showTable" border style="width: 100%" highlight-current-row>
        <el-table-column type="index" label="序号" width="50" align="center"></el-table-column>
        <el-table-column label="设备编号" min-width="130" prop="deviceid" align="center">
        </el-table-column>
        <el-table-column label="设备类型" min-width="95" align="center">
          <template slot-scope="scope">
            <span>{{getDeviceType(scope.row.devicetype)}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="last_online" label="最后在线时间" min-width="140" align="center"></el-table-column>
        <el-table-column v-if="role === 'superadmin'" align="center" label="绑定" width="120">
          <template slot-scope="scope">
            <el-button v-if="scope.row.sys_user_id === 0" size="mini" type="primary" plain @click="bindDevice(scope.row)">绑定账号</el-button>
            <el-button v-else size="mini" type="warning" plain @click="unbindDevice(scope.row)">解绑账号</el-button>
          </template>
        </el-table-column>
        <el-table-column v-if="role === 'superadmin'" align="center" label="操作" width="120">
          <template slot-scope="scope">
            <i v-if="scope.row.devicetype === 851 || scope.row.devicetype === 852" title="编辑" class="el-icon-edit" style="cursor: pointer; font-size: 18px;color: #1ae517" @click="editDevice(scope.row)"></i>
            <i title="解绑" class="el-icon-delete" style="cursor: pointer; font-size: 18px;color: red" @click="delDevice(scope.row)"></i>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div style="margin-top: 10px;height: 40px;text-align: center">
      <el-pagination v-fixZoom @size-change="handleSizeChange" @current-change="handleCurrentChange"
                     :current-page="currentPage" :page-sizes="[10, 20, 50, 100]" :page-size="pageSize"
                     layout="total, sizes, prev, pager, next, jumper" :total="totalCells">
      </el-pagination>
    </div>
    <!--录入设备-->
    <el-dialog :title="showTitle" :visible.sync="addShow" v-if="addShow" width="500px" :show-close="true" :close-on-click-modal="false" center>
      <pad-add-device v-model="addShow" :padRow="padRow" @getFatherChange="getFatherChange"></pad-add-device>
    </el-dialog>
  </div>
</template>

<script>
import padAddDevice from './components/padAddDevice'
import {querypadwithuser, unbinddevicetosysuser} from '../../api/yanglaoyuan'
import {queryorg} from '../../api/organizer'

export default {
  name: 'padDevice',
  components: {padAddDevice},
  data () {
    return {
      deviceid: '',
      loading: false,
      pageSize: 10,
      currentPage: 1,
      totalCells: 0,
      showTable: [],
      showTitle: '录入设备',
      addShow: false,
      padRow: {
        isAdd: 1,
        row: '',
        treeData: []
      },
      role: ''
    }
  },
  created () {
    this.role = this.$store.state.user.role
    this.getPadDevice()
    this.getOrgData()
  },
  methods: {
    // 组织
    getOrgData () {
      this.padRow.treeData = []
      queryorg().then(res => {
        // 所属组织
        let lastLevel = 100
        const arr = res.data.org
        for (let i = 0; i < arr.length; i++) {
          if (arr[i].level < lastLevel) {
            lastLevel = arr[i].level
          }
        }
        for (let i = 0; i < arr.length; i++) {
          if (arr[i].level === lastLevel) {
            this.padRow.treeData.push(arr[i])
          }
        }
        for (let i = 0; i < this.padRow.treeData.length; i++) {
          const child = this.arrayToNode(arr, this.padRow.treeData[i].id)
          if (child.length !== 0) {
            this.padRow.treeData[i].child = child
          }
        }
      }).catch(() => {
        this.loading = false
      })
    },
    // 递归
    arrayToNode (nodesArray, pid) {
      const vm = this
      return nodesArray.filter(value => {
        if (value.orgpid === pid) {
          const arrayToNode = vm.arrayToNode(nodesArray, value.id)
          if (arrayToNode.length > 0) {
            value.child = arrayToNode
          }
          return value
        }
      })
    },
    getFatherChange () {
      this.currentPage = 1
      this.pageSize = 10
      this.getPadDevice()
    },
    getPadDevice () {
      let params = {
        page: this.currentPage,
        size: this.pageSize
      }
      let data = {
        device_id: this.deviceid
      }
      querypadwithuser(params, data).then(res => {
        this.showTable = res.data.devices
        this.totalCells = res.data.cnt
      }).catch(() => {})
    },
    addDevice () {
      this.showTitle = '录入设备'
      this.padRow.isAdd = 1
      this.padRow.isBind = false
      this.addShow = true
    },
    bindDevice (row) {
      this.showTitle = '绑定设备'
      this.padRow.isAdd = 3
      this.padRow.row = row
      this.addShow = true
    },
    unbindDevice (row) {
      let name = row.deviceid
      this.$confirm('此操作将永久解绑该设备【' + name + '】, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'error'
      }).then(() => {
        this.endUnDevice(row)
      }).catch(() => {})
    },
    endUnDevice (row) {
      this.$confirm('此操作将会影响正常使用, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'error'
      }).then(() => {
        let send = {
          imei: row.deviceid
        }
        unbinddevicetosysuser(send).then(res => {
          this.deviceid = ''
          if (this.showTable.length === 1 && this.currentPage > 1) {
            this.currentPage--
          }
          this.getPadDevice()
          this.$notify({title: '成功', message: '解绑成功', type: 'success', duration: 2000})
        })
      }).catch(() => {})
    },
    queryDataTable () {
      this.getPadDevice()
    },
    getDeviceType (type) {
      return this.commonType.getDeviceType(type)
    },
    getDevicePhone (row) {
      if (row.simcardno !== '' && row.simcardno !== '<nil>') {
        return row.simcardno
      } else {
        if (row.pid > 0) {
          return row.p_phone
        } else {
          return row.h_phone
        }
      }
    },
    editDevice (row) {
      this.showTitle = '编辑设备'
      this.padRow.isAdd = 2
      this.padRow.row = row
      this.addShow = true
    },
    delDevice (row) {
      let name = row.deviceid
      this.$confirm('此操作将永久解绑该设备【' + name + '】, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'error'
      }).then(() => {
        this.endDelDevice(row)
      }).catch(() => {})
    },
    endDelDevice (row) {},
    handleSizeChange (val) {
      this.pageSize = val
      this.getPadDevice()
    },
    handleCurrentChange (val) {
      this.currentPage = val
      this.getPadDevice()
    }
  }
}
</script>

<style scoped>
.content-bottom{
  max-height: calc(100% - 100px);
}
</style>



// WEBPACK FOOTER //
// src/components/oldPersonHome/padDevice.vue